var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIadd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.74037 2.73637C1.26632 3.21042 1 3.85337 1 4.52378V13.4682C1 14.1386 1.26632 14.7816 1.74037 15.2556C2.21442 15.7297 2.85737 15.996 3.52778 15.996H12.4722C13.1426 15.996 13.7856 15.7297 14.2596 15.2556C14.7337 14.7816 15 14.1386 15 13.4682V4.52378C15 3.85337 14.7337 3.21042 14.2596 2.73637C13.7856 2.26232 13.1426 1.996 12.4722 1.996H3.52778C2.85737 1.996 2.21442 2.26232 1.74037 2.73637ZM9 4.996C9 4.44372 8.55228 3.996 8 3.996C7.44772 3.996 7 4.44372 7 4.996V7.996H4C3.44772 7.996 3 8.44372 3 8.996C3 9.54829 3.44772 9.996 4 9.996H7V12.996C7 13.5483 7.44772 13.996 8 13.996C8.55228 13.996 9 13.5483 9 12.996V9.996H12C12.5523 9.996 13 9.54829 13 8.996C13 8.44372 12.5523 7.996 12 7.996H9V4.996Z",
    fill: "#009B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIadd);
export default __webpack_public_path__ + "static/media/iadd.27c0253bcb958a3b9e5ec1612af09a91.svg";
export { ForwardRef as ReactComponent };